import { jsx as _jsx } from "react/jsx-runtime";
import { Fields } from "@air/next-icons";
import { HoverCard } from "@air/primitive-hover-card";
import { memo } from "react";
import { CardAction } from "~/components/CardAction";
import { CustomFieldsDisplay } from "~/components/Gallery/CustomFieldsDisplay";
export const GalleryCardCustomFieldsAction = /*#__PURE__*/ memo((param)=>{
    let { customFields, onClick } = param;
    return /*#__PURE__*/ _jsx(HoverCard, {
        openDelay: 0,
        align: "start",
        trigger: /*#__PURE__*/ _jsx(CardAction, {
            "data-testid": "CUSTOM_FIELDS_INDICATOR",
            icon: /*#__PURE__*/ _jsx(Fields, {
                className: "size-4"
            }),
            onClick: onClick
        }),
        children: /*#__PURE__*/ _jsx(CustomFieldsDisplay, {
            onClick: onClick,
            style: {
                minWidth: 250,
                maxWidth: 400
            },
            customFields: customFields,
            shouldShowLabelInline: true
        })
    });
});
GalleryCardCustomFieldsAction.displayName = "GalleryCardCustomFieldsAction";
